'use client'

import { useLocale, useTranslations } from 'next-intl'

import { ModelsNews } from '@/api/generated-api'
import Loader from '@/shared/ui/Loader'

import NewsGridCard from '../../../components/NewsCard/NewsGridCard'
import S from './MoreInSports.module.scss'

interface MoreInSportsViewProps {
  items: ModelsNews[]
  isLoading: boolean
}

const MoreInSportsView = ({ items, isLoading }: MoreInSportsViewProps) => {
  const t = useTranslations('news')
  const locale = useLocale()

  if (isLoading) {
    return (
      <div className={S.moreInSports}>
        <Loader variant="inline" />
      </div>
    )
  }

  if (items.length === 0) {
    return null
  }

  return (
    <div className={S.moreInSports}>
      <h2 className={S.title}>{t('more.title')}</h2>
      <div className={S.cards}>
        {items.map(news => (
          <NewsGridCard key={news.id} news={news} locale={locale} />
        ))}
      </div>
    </div>
  )
}

export default MoreInSportsView
